import { IconButton as MuiIconButton, styled } from "@mui/material";

export const IconButton = styled(MuiIconButton)(({ theme }) => ({
  width: 30,
  height: 30,
}));
